import { render, staticRenderFns } from "./TripSetup.vue?vue&type=template&id=3710463c&"
import script from "./TripSetup.vue?vue&type=script&lang=js&"
export * from "./TripSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports